import { MedicalItemsTab } from "@/Common/Models/Patient/PatientEnums";
import { EnumPatientSummaryMedicationDisplayStatus } from "@/Patient/Models/MedicalSummary/MedicalItemMedicationDisplayStatus";
import { MedicationModel } from "@/Patient/Models/Medication/MedicationModel";

import styles from "./ActiveMedicationSection.module.css";

interface IActiveMedicationSectionProps {
    activeMedication: MedicationModel[];
    onMedicationItemClick: (model: MedicationModel, view: MedicalItemsTab) => void;
}

function ActiveMedicationSection(props: IActiveMedicationSectionProps): JSX.Element {
    return (
        <>
            {props.activeMedication?.map(activeMedication => (
                <a
                    data-cy="active-medication"
                    key={"Medication-" + activeMedication.Model.Id}
                    onClick={() => props.onMedicationItemClick(activeMedication, MedicalItemsTab.Medication)}
                    className={styles.container}
                >
                    {`${activeMedication.GetName()} ${activeMedication.GetDosageString() ?? ""} `}
                    <span
                        className={`${styles.renewalTag} ${activeMedication.Model.SummaryDisplayStatus === EnumPatientSummaryMedicationDisplayStatus.ShowExpired ? styles.expired : ""}`}
                    >
                        {activeMedication.GetRenewalString()}
                    </span>
                </a>
            ))}
        </>
    );
}

export { ActiveMedicationSection };
